import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import { AppProvider } from './AppContext.jsx'
import { CookieConsentProvider } from './CookieConsent.jsx'

import './App.css'
import HomePage from './HomePage.jsx'
import PrivacyPolicy from './PrivacyPolicy.jsx'
import TermsOfUse from './TermsOfUse.jsx'
import Security from './Security.jsx'
import MedicalDisclaimer from './MedicalDisclaimer.jsx'
import Blog from './Blog.jsx'
import Contact from './Contact.jsx'
import ForProfessionals from './ForProfessionals.jsx'
import AboutUs from './AboutUs.jsx'

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <CookieConsentProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/how-it-works" element={<HomePage section="how-it-works" />} />
            <Route path="/features" element={<HomePage section="features" />} />
            <Route path="/benefits" element={<HomePage section="benefits" />} />
            <Route path="/testimonials" element={<HomePage section="testimonials" />} />
            <Route path="/pricing" element={<HomePage section="pricing" />} />
            <Route path="/faq" element={<HomePage section="faq" />} />
            <Route path="/final-cta" element={<HomePage section="final-cta" />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/security" element={<Security />} />
            <Route path="/medical-disclaimer" element={<MedicalDisclaimer />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/for-professionals" element={<ForProfessionals />} />
            <Route path="/about-us" element={<AboutUs />} />
          </Routes>
        </CookieConsentProvider>
      </BrowserRouter>
    </AppProvider>
  )
}

export default App
